import { createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { IGiftCardDetail } from './types/giftCard';
import { IAPIGetListGiftCardByCategoryParams } from './types/api';

const getGiftCardToBuy = createAsyncAction<string>(PREFIX_ACTIONS + 'getGiftCardToBuy');

const getGiftCardDetail = createAsyncAction<{ id: string, shopId?: string | null }, IGiftCardDetail>(PREFIX_ACTIONS + 'getGiftCardDetail');
const getListCategoryGiftCard = createAsyncAction(PREFIX_ACTIONS + 'getListCategoryGiftCard');
const getListGiftCardByCategory = createAsyncAction<IAPIGetListGiftCardByCategoryParams>(PREFIX_ACTIONS + 'getListGiftCardByCategory');

const giftCardActions = {
  getGiftCardToBuy,
  getGiftCardDetail,
  getListCategoryGiftCard,
  getListGiftCardByCategory,
};

export default giftCardActions;

